import React from 'react';
import { useNavigate } from "react-router-dom";
import Button from "@material-ui/core/Button/Button";
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import './ButtonGroup.scss';
import QuizResultPdf from '../../pages/CreatePdf/QuizResultPdf';

/**
 * Results actions.
 * @param props
 * @returns {*}
 * @constructor
 */
const ResultsButtonGroup = props => {
    const t = useTranslations();
    const { quizResults, downloadPdf, quizId } = props;
    const headerData = quizResults && quizResults.data && quizResults.data.headerData ?
        quizResults.data.headerData : {};

    const navigate = useNavigate();

    //change location.
    function changeLocation(location) {
        navigate(location);
    }

    return (
        <div className="continue-button">
            <Button onClick={() => changeLocation('/my-app/quiz/view/' + headerData.slug)} className="view-solution">
                {t('view_solution')}
            </Button>
            {/* <Button onClick={()=>changeLocation('/my-app/practice-tests')} className="remove-mobile-btn">
                {t('new_quiz')}
            </Button> */}
            {downloadPdf &&
            <QuizResultPdf quizId={quizId}/>
            }
        </div>
    );
};

export default ResultsButtonGroup;
